import React from 'react';
import classNames from 'classnames';
import { Label, Icon } from 'semantic-ui-react';

const CondensedLabeledButton = props => {
    const handleKeyDown = e => {
        if (e.key === 'Enter') {
            props.onClick();
        }
    }

    const inheritedClasses = props.className ? props.className.split(' ') : '';
    const { label, icon, primary, colored } = props;
    const buttonClasses = classNames(
        'ui',
        'custom-condensed-labeled-button',
        inheritedClasses,
        { primary },
        { colored }
    );

    return (
        <div className={buttonClasses}
            onClick={props.onClick}
            onKeyDown={handleKeyDown}>
            <Label tabIndex={0}>
                {
                    icon &&
                    <Icon name={icon} />
                }
                {label}
            </Label>
        </div>
    );
}

export default CondensedLabeledButton;
